import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardLoans = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#ff897e",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.93333 2.86664H14.0667C14.0667 2.86664 15 2.86664 15 3.79997V12.2C15 12.2 15 13.1333 14.0667 13.1333H1.93333C1.93333 13.1333 1 13.1333 1 12.2V3.79997C1 3.79997 1 2.86664 1.93333 2.86664Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 6.1983H15",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.80005 10.3617H4.98456",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCreditCardLoans;
